import i18n from "../../i18n";

const useSwitchLanguageProfil = () => {
  return (languageId) => i18n.changeLanguage(languageId);
};

export default useSwitchLanguageProfil;
